export default "__VITE_ASSET__43591a53__"